export enum RATE_CARD_TYPE {
  ADD_HOC = "AdHoc",
  PACKAGE = "Package"
}
